// SalesShark — Slovak
const sk = {
    code: "sk",
    label: "Slovenčina",
    short: "SK",
    flag: "🇸🇰",
    htmlLang: "sk",
    nav: {
        home: "Úvod",
        services: "Služby",
        about: "O nás",
        references: "Referencie",
        contact: "Kontakt",
        faq: "FAQ",
        consultation: "Bezplatná konzultácia",
    },
    hero: {
        eyebrow: "International Sales Agency",
        headingA: "Každá minúta, keď si nevyberiete nás,",
        headingB: "hrá do karát vašim konkurentom.",
        subheading:
            "Predvídateľný, merateľný sales pipeline od výberu cieľového trhu až po podpis zmluvy — postavený na vlastnej databáze firiem, cielených e-mailových kampaniach a viacjazyčných telefonátoch.",
        ctaPrimary: "Bezplatná konzultácia",
        ctaSecondary: "Naše služby",
        marketsLabel: "Aktívne trhy",
        markets: [
            { code: "HU", name: "Maďarsko" },
            { code: "SK", name: "Slovensko" },
            { code: "CZ", name: "Česko" },
            { code: "AT", name: "Rakúsko" },
        ],
    },
    quickServices: {
        eyebrow: "Čo ponúkame",
        heading: "Deväť oblastí, jeden jednotný predajný stroj.",
        subheading:
            "Od firemnej databázy po podpis zmluvy — celú cestu s jedným tímom.",
        items: [
            "Databáza firiem podľa krajín",
            "Plánovanie stretnutí",
            "Cold calling",
            "Telemarketing",
            "Zabezpečenie zamestnanca",
            "Expanzia",
            "Branding",
            "Marketing",
            "Sociálne siete",
        ],
    },
    results: {
        eyebrow: "SalesShark",
        heading: "Rozhoduje výsledok.",
        bullets: [
            "SalesShark je tím orientovaný na výsledky pri získavaní zákazníkov: staviame predvídateľný, merateľný pipeline od výberu cieľového trhu až po podpis zmluvy.",
            "Naša silná stránka: vlastná firemná databáza štruktúrovaná podľa krajín (HU / SK / CZ / AT), na ktorú staviame cielené e-mailové kampane a telefonáty pre kvalifikované stretnutia, a poskytujeme dedikovaného SALES pracovníka na uzatvorenie obchodov.",
            "Jazyky: maďarský, slovenský, český, anglický, nemecký.",
            "Veríme v silu ľudských vzťahov: dôvera, korektná komunikácia a dôsledné sledovanie sú podľa nás silnejšie ako akýkoľvek „trik”.",
        ],
        ctaPrimary: "Bezplatná konzultácia",
        ctaSecondary: "Kontakt",
    },
    detailedServices: {
        eyebrow: "Naše služby",
        heading: "Jasný proces, sedem modulov generujúcich príjmy.",
        subheading:
            "Od firemnej databázy po mesačný report — každý modul je súčasťou jedného jednotného predajného stroja.",
        ctaMore: "Zistiť viac",
        items: [
            { title: "Databáza firiem HU / SK / CZ / AT", text: "Zoznam firiem s filtrami a kontaktmi." },
            { title: "E-mail marketing", text: "Hromadné odosielanie e-mailov + CTA na rezerváciu termínu + reporting." },
            { title: "Telefonické oslovovanie", text: "Cold calls, telemarketing v jazykoch HU / SK / CZ / EN / DE." },
            { title: "Zabezpečenie zamestnanca", text: "Krátkodobé aj dlhodobé predajné zdroje podľa potreby v HU / SK / CZ / EN / DE s naším systémom + starostlivosť o existujúcich klientov." },
            { title: "Marketing + PPC", text: "Branding, videá, kreatívy, vizuálna identita, propagačné materiály, vizitky, plánovanie a spustenie kampaní na sociálnych sieťach." },
            { title: "Podpora expanzie (HU / SK / CZ / AT)", text: "Prieskum trhu, založenie firmy, bankový účet, ďalšia administratívna pomoc." },
            { title: "Mesačný report", text: "Statusy, KPI, ďalšie kroky, pravidelný súhrn." },
        ],
    },
    problems: {
        eyebrow: "Ktoré z nich platí pre Vás?",
        heading: "Povedzte nám!",
        subheading:
            "Ak je Vám čo len jedna z nasledujúcich situácií povedomá, pravdepodobne dokážeme spolupracovať.",
        cta: "Bezplatná konzultácia",
        items: [
            "Mám dobrý produkt/službu, ale chcem viac zákazníkov.",
            "Chcem expandovať do inej krajiny.",
            "Potrebujem profesionálneho marketéra.",
            "Nemám prehľad o práci môjho platného kolegu: koľko firiem sme obvolali?",
            "Potrebujem nového kolegu.",
            "Chcem osloviť rozhodovateľov, nie generických kontaktov.",
            "Nemám denne čas hľadať a telefonovať.",
            "Chcem riešenia, nie rečnenie.",
            "Málo sa venujem existujúcim klientom.",
        ],
    },
    references: {
        eyebrow: "Referencie",
        headingA: "Úspechy našich partnerov",
        headingB: "sú našou najdôležitejšou referenciou.",
        statBadge: "50+ partnerov · 4 trhy · 5 jazykov",
        verifiedBadge: "Overené",
        items: [
            { company: "WHC SLOVAKIA", role: "CEO", text: "Mimoriadne oceňujeme prístup tímu, presnosť a to, že myslia v reálnych obchodných výsledkoch. SalesShark je partner, ktorému môže rastovo orientovaná firma s dôverou zveriť časť alebo celé svoje predajné procesy." },
            { company: "iNTRETECH", role: "CEO", text: "V spolupráci s Antalom a Antóniou sme našli partnera, ktorý v našich predajných procesoch vytvára reálnu hodnotu. Kvalita oslovení, transparentnosť reportov a odborná pripravenosť tímu nás utvrdila, že dátovo riadený sales je dnes už nevyhnutný." },
            { company: "MOTIM ZRT.", role: "CEO", text: "S tímom SalesShark bolo rýchlo jasné, že sme nevybrali jednoduchého poskytovateľa služieb, ale skutočného strategického partnera. Ich systém je transparentný, komunikácia profesionálna a každá aktivita merateľná. SalesShark dodáva konkrétne, kontrolovateľné výsledky – preto s nimi pracujeme." },
        ],
    },
    goal: {
        eyebrow: "Náš cieľ",
        heading: "Prinášať výsledky — od lepšej starostlivosti o klientov až po nové trhy.",
        p1: "Prinášať výsledky, od lepšej starostlivosti o klientov cez zvýšenie predaja až po otváranie úplne nových trhov.",
        p2: "S nami získate spoľahlivého partnera, ktorý krok za krokom podporuje rast Vášho podnikania.",
        ctaContact: "Kontakt",
        ctaPresentation: "Firemná prezentácia",
    },
    about: {
        eyebrow: "O nás",
        headingA: "Pracujeme s dátami,",
        headingB: "meriame vo výsledkoch,",
        headingC: "veríme v ľudské vzťahy.",
        story: {
            eyebrow: "Náš príbeh",
            p1: "V roku 2023 sme v Bratislave založili medzinárodnú personálnu agentúru GLOBEFOX — odtiaľ vzišlo medzinárodné zameranie na sales, ktoré je dnes základom SalesShark.",
            p2: "Dnes už nábor prebieha v Maďarsku, na Slovensku a v Česku a spolupracujeme s viac ako 50 partnermi vrátane výrobných gigantov a lídrov trhu. Popri personálnom sprostredkovaní pomáhame klientom aj so zakladaním firiem a účtovníctvom.",
            p3: "Naše medzinárodné skúsenosti a viacjazyčný tím nám umožňujú zastupovať klientov cezhranične na skutočne profesionálnej úrovni.",
        },
        stats: [
            { n: "2023", label: "Založené v Bratislave" },
            { n: "50+", label: "Aktívnych partnerov" },
            { n: "4", label: "Trhy · HU / SK / CZ / AT" },
            { n: "5", label: "Jazyky · HU / SK / CZ / EN / DE" },
        ],
        pillars: {
            eyebrow: "Prečo my",
            headingA: "Štyri princípy, jedna niť:",
            headingB: "výsledok.",
            items: [
                { title: "Dátovo riadený sales", text: "Z vlastnej firemnej databázy štruktúrovanej podľa krajín staviame merateľný pipeline — nepracujeme na tušení." },
                { title: "Merateľné výsledky", text: "Týždenný status, KPI, reporty — vždy viete, kde proces stojí a čo je ďalší krok." },
                { title: "Ľudské vzťahy", text: "Dôvera, korektná komunikácia a dôsledné sledovanie sú silnejšie ako akýkoľvek trik." },
                { title: "Viacjazyčné operácie", text: "Klientov zastupujeme v maďarskom, slovenskom, českom, anglickom a nemeckom jazyku cezhranične." },
            ],
        },
        team: {
            eyebrow: "Tím",
            heading: "Tváre za procesmi.",
            members: [
                {
                    role: "Konateľka / CEO · Medzinárodná právnička",
                    bio: [
                        "V roku 2023 sme v Bratislave založili medzinárodnú personálnu agentúru GLOBEFOX. Ja som sa pripojila ako medzinárodná právnička a hovorím štyrmi jazykmi.",
                        "To umožnilo, aby GLOBEFOX od začiatku smeroval medzinárodne a dnes prebieha nábor v Maďarsku, na Slovensku a v Česku. Spolupracujeme s viac ako 50 partnermi vrátane výrobných gigantov a lídrov trhu.",
                        "Naše medzinárodné skúsenosti a viacjazyčný tím nám umožňujú zastupovať klientov cezhranične na skutočne profesionálnej úrovni.",
                    ],
                },
                {
                    role: "COO / Prevádzkový riaditeľ · Zakladateľ",
                    bio: [
                        "Zodpovedám za stratégiu a budovanie predajných systémov: mojím cieľom je, aby každý náš klient dostal také riešenie sales, ktoré prinesie reálny rast a stabilné získavanie zákazníkov.",
                        "Denne sa venujem plánovaniu kampaní, dátovo riadenej optimalizácii a procesom, ktoré zaručujú, že naši klienti získajú viac záujemcov, stretnutí a nových zákazníkov.",
                        "Naším cieľom je, aby SalesShark bola najsilnejšia a najspoľahlivejšia sales agentúra v regióne — s reálnymi výsledkami, nie sľubmi.",
                    ],
                },
            ],
        },
    },
    contact: {
        eyebrow: "Kontakt",
        headingA: "Máte otázku?",
        headingB: "Odpovieme do 24 hodín.",
        ctaConsultation: "Bezplatná konzultácia",
        officeTitle: "Naše kancelárie",
        officeSubtitle: "Štyri kancelárie v regióne",
        offices: [
            { country: "HU", city: "2900 Komárom" },
            { country: "SK", city: "811 01 Bratislava" },
            { country: "HU", city: "9200 Mosonmagyaróvár" },
            { country: "SK", city: "943 01 Dunaszerdahely" },
        ],
        company: {
            name: "GLOBEFOX s.r.o.",
            addressLine1: "Sabinovska 9., Bratislava",
            addressLine2: "831 04, Slovensko",
            id: "IČO: 55 100 376",
        },
    },
    form: {
        eyebrow: "Napíšte nám",
        heading: "Nechajte správu — odpovieme do 24 hodín.",
        labels: {
            name: "Meno",
            email: "E-mail",
            phone: "Telefón",
            company: "Firma",
            message: "Správa",
        },
        placeholders: {
            name: "Ján Novák",
            email: "jan@firma.sk",
            phone: "+421 900 123 456",
            company: "Acme s.r.o.",
            message: "S čím Vám môžeme pomôcť?",
        },
        companyHelper: "Voliteľné — ako súkromná osoba nechajte prázdne.",
        disclaimer:
            "Odoslaním súhlasíte s tým, že Vás môžeme kontaktovať na uvedených kontaktoch.",
        submit: "Odoslať správu",
        sending: "Odosielam…",
        successTitle: "Správu sme prijali.",
        successText: "Odpovieme do 24 hodín na uvedený e-mail.",
        errorTitle: "Bohužiaľ sa nepodarilo odoslať.",
        errorText: "Skúste to prosím znova alebo nás kontaktujte priamo.",
    },
    faq: {
        eyebrow: "FAQ",
        headingA: "Časté otázky.",
        headingB: "Krátke, priame odpovede.",
        items: [
            { q: "V ktorých krajinách pôsobíte?", a: "Sme aktívni v Maďarsku, na Slovensku, v Česku a v Rakúsku. S vlastnou firemnou databázou štruktúrovanou podľa krajín a viacjazyčným tímom (maďarský, slovenský, český, anglický, nemecký) pomáhame partnerom vstúpiť na tieto trhy a rásť na nich." },
            { q: "Aká je veľkosť Vašej firemnej databázy?", a: "Maďarsko: 16 000 firiem, Slovensko: 13 000 firiem, Rakúsko: 47 000 firiem, Česko: 3 000 firiem. Databázu priebežne aktualizujeme a možno v nej filtrovať podľa odvetvia, veľkosti firmy, lokality a regiónu." },
            { q: "V akých jazykoch vykonávate telefonické oslovovanie?", a: "Hovory aj follow-up realizujeme v maďarskom, slovenskom, českom, anglickom a nemeckom jazyku." },
            { q: "Sú e-mailové kampane odosielané z Vášho mena?", a: "Nie. E-mailové sekvencie odosielame z Vášej firemnej e-mailovej adresy, takže priamo môžete sledovať odoslania, odpovede a vývoj stretnutí." },
            { q: "Čo obsahuje mesačný report?", a: "Statusy, KPI, ďalšie kroky a pravidelný súhrn — aby ste vždy vedeli, kde pipeline stojí." },
            { q: "Ako môžeme začať spoluprácu?", a: "Rezervujte si 15-minútovú bezplatnú konzultáciu v kalendári. Zmapujeme cieľový trh, Vašu aktuálnu situáciu a navrhneme najlepšiu vstupnú stratégiu." },
        ],
        notFoundEyebrow: "Nenašli ste odpoveď?",
        notFoundHeading: "Spýtajte sa nás priamo.",
        ctaConsultation: "Bezplatná konzultácia",
        ctaContact: "Kontakt",
    },
    footer: {
        eyebrow: "Začnite ešte dnes",
        heading: "Porozprávajme sa o Vašom ďalšom trhu.",
        subheading:
            "15-minútová bezplatná konzultácia — merateľný sales pipeline na trhoch HU / SK / CZ / AT.",
        cta: "Bezplatná konzultácia",
        tagline:
            "International Sales Agency. Získavanie zákazníkov orientované na výsledky, vlastná firemná databáza a dedikovaný sales pracovník pre trhy HU / SK / CZ / AT.",
        contactHeading: "Kontakt",
        menuHeading: "Menu",
        copyright: (year) =>
            `© ${year} SalesShark · GLOBEFOX s.r.o. Všetky práva vyhradené.`,
        roles: {
            antonia: "Antónia Somogyi · CEO",
            antal: "Antal Korcz · COO",
        },
    },
    services: {
        hero: {
            eyebrow: "Naše služby",
            headingA: "Digitálny a ľudský predaj v súlade —",
            headingB: "optimalizované na výsledok.",
            subheading:
                "Šesť modulov, jeden jednotný proces — od prieskumu trhu po osobné zastupovanie.",
        },
        sideNavTitle: "Služby",
        eyebrows: {
            dataDriven: "Dátovo riadený predaj",
            process: "Proces",
            service: "Služba",
        },
        ctaConsultation: "Bezplatná konzultácia",
        ctaContact: "Kontakt",
        bottomCta: {
            eyebrow: "Pripravení na ďalší krok?",
            heading: "15-minútový rozhovor o Vašom ďalšom trhu.",
            subheading:
                "Ukážeme Vám, ako staviame merateľný pipeline s vlastnou databázou na trhoch HU / SK / CZ / AT.",
        },
        sections: {
            cegadatbazis: {
                label: "Databáza firiem",
                title: "Databáza firiem",
                intro: [
                    "Databáza obsahuje aj krátke firemné informácie a webové kontakty.",
                    "Ak ste doteraz hľadali potenciálnych cieľových partnerov cez Google, s ňou výrazne zrýchlite prieskum trhu a oslovovanie.",
                    "Databázu s menovitými kontaktmi priebežne aktualizujeme.",
                ],
                statLabel: "firiem",
                stats: [
                    { country: "Maďarsko", value: "16 000" },
                    { country: "Slovensko", value: "13 000" },
                    { country: "Rakúsko", value: "47 000" },
                    { country: "Česko", value: "3 000" },
                ],
                filtersTitle: "K dispozícii sú nasledovné filtre:",
                filters: ["Odvetvie", "Veľkosť firmy (počet zamestnancov)", "Lokalita", "Región"],
            },
            email: {
                label: "E-mail marketing",
                title: "E-mail marketing",
                steps: [
                    { title: "Výber cieľovej skupiny z databázy firiem", text: "Filtrovanie podľa odvetvia, regiónu, veľkosti firmy." },
                    { title: "Hromadné e-mailové sekvencie", text: "Newsletter, predstavovací a ponukový e-mail s naplánovaným follow-upom a možnosťou odhlásenia." },
                    { title: "Vstavaná rezervácia termínu (CTA)", text: "Príjemca si jedným klikom rezervuje 15-minútové stretnutie, systém udalosť automaticky zaznamená do kalendára." },
                    { title: "Sledovanie a reporting v reálnom čase", text: "Doručenie, otvorenie, kliknutie, odpoveď, rezervácia — merateľné pre kampaň aj pre príjemcu." },
                    { title: "Z Vašej firemnej e-mailovej adresy", text: "E-mailové sekvencie odosielame z Vašej firemnej adresy, takže priamo sledujete odoslania, odpovede a vývoj stretnutí." },
                ],
            },
            phone: {
                label: "Telefonické oslovovanie",
                title: "Telefonické oslovovanie",
                items: [
                    { title: "Cold calls", text: "Firmy oslovujeme z databázy podľa pripraveného scenára." },
                    { title: "„Warm” hovory", text: "Voláme aj tým, ktorí prejavili aktivitu v e-mailovej kampani." },
                    { title: "Dohodnutie stretnutia", text: "Cieľom je dostať sa k rozhodovateľovi a rezervovať stretnutie pre Vášho obchodníka." },
                    { title: "Telemarketing", text: "Zaškolenie a telefonický predaj + report." },
                    { title: "Viacjazyčné oslovovanie", text: "Hovory a follow-up realizujeme aj v maďarskom, slovenskom, českom, anglickom a nemeckom jazyku." },
                    { title: "Odovzdanie a dokumentácia", text: "S kým, o čom, aká je potreba, ďalší krok, dohodnutý termín alebo odmietnutie." },
                ],
            },
            staff: {
                label: "Zabezpečenie zamestnanca",
                title: "Zabezpečenie zamestnanca",
                items: [
                    { title: "Predaj, telesales, administratíva alebo koordinácia", text: "Z CV si vyberáte príležitostného alebo dlhodobého partnera, ktorý bude „tvárou” Vašej firmy a bude komunikovať vo Vašom mene v HU / SK / CZ / EN / DE." },
                    { title: "Systém", text: "Pracovník používa náš workflow (statusy, follow-up, meeting brief, reporty)." },
                    { title: "Kompletné vybavenie na požiadanie", text: "Firemné auto, telefón a laptop, aby práca mohla začať okamžite na profesionálnej úrovni." },
                    { title: "Onboarding a zaškolenie", text: "Príprava na produkt a cieľový trh." },
                    { title: "Odborný dohľad", text: "Vedenie a kontrola kvality, týždenný status/report + pipeline, aby sme vždy vedeli, kde stojíme." },
                ],
            },
            marketing: {
                label: "Marketing",
                title: "Marketing",
                items: [
                    { title: "Branding", text: "Návrh vizuálnej identity a loga." },
                    { title: "Kreatívna produkcia", text: "Profesionálne fotografie, videá, grafické materiály, animácie — aj vo viacerých jazykoch." },
                    { title: "Predajné materiály", text: "Prezentácie, ponuky, one-pager, vizitka, propagačné materiály." },
                    { title: "Online reklama (PPC)", text: "Plánovanie, nastavenie a priebežná optimalizácia (FB/IG/Google)." },
                    { title: "Sociálne siete — obsah a kampane", text: "Príspevky, reklama." },
                    { title: "Meranie a reporting", text: "Sledovanie KPI, závery, ladenie a škálovanie." },
                ],
            },
            expansion: {
                label: "Expanzia",
                title: "Expandujete? Pomôžeme!",
                steps: [
                    { title: "Prieskum trhu a určenie cieľového trhu", text: "Zameranie podľa krajiny (odvetvie, veľkosť firmy, región, konkurencia)." },
                    { title: "Vstupná stratégia a plán", text: "Komu predávame, s akou ponukou, cez ktoré kanály, v akých krokoch." },
                    { title: "Cielený zoznam firiem a kontaktov rozhodovateľov", text: "V danej krajine, na základe vlastnej databázy (HU / SK / CZ / AT)." },
                    { title: "Vstupné outreach kampane", text: "Segmentované predstavovacie e-maily + viackrokový follow-up." },
                    { title: "Viacjazyčné telefonáty a plánovanie stretnutí", text: "V jazykoch HU / SK / CZ / EN / DE, s kvalifikovanými stretnutiami." },
                    { title: "Osobné zastupovanie", text: "Príležitostné aj dlhodobé projekty." },
                    { title: "Reporting a optimalizácia", text: "Meranie výsledkov, ladenie, škálovanie na najlepšie fungujúce segmenty." },
                    { title: "Voliteľné: založenie firmy, preklady, otvorenie účtu, ďalšia administratíva", text: "Praktická pomoc pri štarte a prevádzke." },
                ],
            },
        },
    },
    languageSwitcher: {
        label: "Jazyk",
        aria: "Vybrať jazyk",
    },
};

export default sk;
